import { ReactQueryDevtools } from 'react-query/devtools';

export default ReactQueryDevtools;
